import { Controller } from 'stimulus';
import { googleTagManager } from "../packs/scripts/helpers/GoogleTagManager";

export default class extends Controller {
  initialize() {
    googleTagManager.gaNoResults();
  }
}
